import { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DialogLayouts from "./components/LayoutsDialog/Index";
import Access from "./components/Access/Index";
import MainContent from "./components/MainContent/Index";
import NavBar from "./components/NavBar/Index";
import { useAuth } from "./context/AuthContext";
import { getGroupedLayoutsByUser } from "./services/Layouts";
import { t } from "i18next";

export default function Index() {
  const [openLayoutsModal, setOpenLayoutsModal] = useState(false);
  const [groupedLayouts, setGroupedLayouts] = useState(null);
  const [themeName, setThemeName] = useState(
    localStorage.getItem("darkMode") === "true" ? "dark" : "light",
  );
  const { user } = useAuth();

  useEffect(() => {
    getLayouts();
  }, []);

  const newTheme = createTheme({
    palette: {
      primary: {
        main: "#ff5722",
      },
      mode: themeName,
    },
  });

  const handleOpenLayouts = () => {
    setOpenLayoutsModal(true);
  };
  const handleCloseLayouts = async () => {
    getLayouts();
    setOpenLayoutsModal(false);
  };
  const handleChangeTheme = (darkmode) => {
    setThemeName(darkmode ? "dark" : "light");
  };

  const getLayouts = () => {
    getGroupedLayoutsByUser()
      .then((data) => {
        setGroupedLayouts(data.data);
      })
      .catch((e) => {});
  };

  return (
    <ThemeProvider
      theme={newTheme}
      sx={{
        background: "silver",
      }}
    >
      <NavBar
        handleOpenLayouts={handleOpenLayouts}
        handleChangeTheme={handleChangeTheme}
      />

      <Box
        sx={{
          display: "flex",
          minHeight: "100%",
          bgcolor: "background.default",
          color: "text.primary",
          maxHeight: "100%",
        }}
      >
        {user ? (
          <>
            <MainContent groupedLayouts={groupedLayouts} />
            <DialogLayouts
              open={openLayoutsModal}
              handleCloseMsg={handleCloseLayouts}
            >
              <Button onClick={handleCloseLayouts} variant="contained">
                {t("close")}
              </Button>
            </DialogLayouts>
          </>
        ) : (
          <Access />
        )}
      </Box>
    </ThemeProvider>
  );
}
